let bool = false
let baseURL = null
if (process.env.NODE_ENV == 'development') { //开发环境走的地址

} else if (process.env.NODE_ENV == 'production') { //生产环境地址
    bool = true;
    baseURL = "https://app.victoriazj.com:4431"
} else if (process.env.NODE_ENV == 'testing') { //测试环境地址
    bool = true;
    baseURL = "https://app.hsltm.com:4431"
}
export default {
    bool,
    baseURL
}


// WEBPACK FOOTER //
// ./src/common/env.js